// ConfigContext.js
import React, {
  createContext,
  FC,
  ReactNode,
  useMemo,
} from "react";
import { useAppSelector } from "../store";
import { useCustomKeycloak } from "../hooks/useCustomKeycloak";
import { USER_TYPES } from "../enums/user";
import { IUser2 } from "../models/user copy";
import { IDirector } from "../models/director";

export type IAuthContext = Record<
  "isAdmin" | "isCoach" | "isAthlete" | "isDirector",
  boolean
>;

export const AuthContext = createContext({
  isAdmin: false,
  isCoach: false,
  isAthlete: false,
  isDirector: false,
  userImage: undefined as undefined | string,
});

export const ConfigProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { keycloak } = useCustomKeycloak();
  const selectedEntity = useAppSelector((st) => st.me.selectedEntity);
  const output = useMemo(() => {
    const isDirector = !!(keycloak as any).tokenParsed?.directorIds?.includes?.(
      selectedEntity?._id
    );
    let userImage = undefined;
    if (isDirector && typeof (selectedEntity as any)?.image === "string") {
      userImage = `${process.env.REACT_APP_BASE_URL_IMAGE}${
        (selectedEntity as any)?.image
      }`;
    } else if (
      !isDirector &&
      typeof (selectedEntity as any)?.image?.image === "string"
    ) {
      userImage = `${process.env.REACT_APP_BASE_URL_IMAGE}${
        (selectedEntity as any)?.image?.image
      }`;
    }

    return {
      userImage,
      selectedEntity,
      isDirector,
      isAdmin:
        (selectedEntity as IUser2<IDirector>)?.type ===
        USER_TYPES.ADMINISTRATOR,
      isAthlete:
        (selectedEntity as IUser2<IDirector>)?.type === USER_TYPES.ATHLETE,
      isCoach: (selectedEntity as IUser2<IDirector>)?.type === USER_TYPES.COACH,
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak, selectedEntity]);

  return <AuthContext.Provider value={output}>{children}</AuthContext.Provider>;
};
